module.exports = __webpack_public_path__ + "img/layer-2.f26356d1.svg";